export default __webpack_public_path__ + "advantage-1d7e7e6.png";